// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__r6YTX","themeBtn":"navbar_themeBtn__LpfqG"};